<template lang="pug">
  b-modal#viewFreespinLogDetail(
  ref="viewFreespinLogDetail"
  :title="$t('ui.combine.view_freespin_log_detail')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.member_id')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="member_id"
          required
          alphaNum
          type="text"
          :dirty="$v.member_id.$dirty"
          :error="$v.member_id.$error"
          v-model.trim.lazy="$v.member_id.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.member_id" :name="$t('ui.member_id')")
      b-form-group(:label="$t('ui.action_date')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="action_date"
          required
          alphaNum
          type="text"
          :dirty="$v.action_date.$dirty"
          :error="$v.action_date.$error"
          v-model.trim.lazy="$v.action_date.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.action_date" :name="$t('ui.action_date')")
      b-form-group(:label="$t('ui.action_by')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="action_by"
          required
          alphaNum
          type="text"
          :dirty="$v.action_by.$dirty"
          :error="$v.action_by.$error"
          v-model.trim.lazy="$v.action_by.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.action_by" :name="$t('ui.action_by')")
      b-form-group(:label="$t('ui.raw_msg')" disabled).mb-3
        b-form-textarea(v-model="raw_msg" rows="10")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, minLength, maxLength, alphaNum, integer, email, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      member_id: "",
      action_date: "",
      action_by: "",
      raw_msg: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
  },
  validations: {
    member_id: {
      required
    },
    action_by: {
      required
    },
    action_date: {
      required
    }
  },
  methods: {
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.member_id = this.item.member_id;
      this.action_date = this.$moment(this.item.action_date).format('YYYY-MM-DD, HH:mm:ss');
      this.action_by = this.item.action_by;
      var obj = JSON.parse(this.item.request_data);
      this.raw_msg = JSON.stringify(obj, undefined, 4);
      // this.raw_msg = this.item.raw_msg;
    }
  }
};
</script>
